import { render, staticRenderFns } from "./UkrainiantreasuresShop.vue?vue&type=template&id=6d378d92&scoped=true"
import script from "./UkrainiantreasuresShop.vue?vue&type=script&lang=js"
export * from "./UkrainiantreasuresShop.vue?vue&type=script&lang=js"
import style0 from "./UkrainiantreasuresShop.vue?vue&type=style&index=0&id=6d378d92&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6d378d92",
  null
  
)

export default component.exports